import React, { useContext } from 'react';
import Credentials from '.';
import { AuthContext } from 'context/AuthContext';
import { AlertsContext } from 'context/AlertsContext';
import { useHistory } from 'react-router-dom';
import { api_srv } from 'services';
import routes from "routes";
import { loginIntermediary, createIntermediary } from 'services/authSrv';

const CredentialsContainer = () => {
	const history = useHistory();

	// context
	const { alert, setAlert, credentials, setCredentials, user, setUser } = useContext(AuthContext);
	const { setShowAlert } = useContext(AlertsContext);

	const names = `${credentials.firstName}  ${credentials.lastName}`;

	const handleCredentialsChange = (evt) => {
		const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
		setCredentials({
			...credentials,
			[evt.target.name]: value,
		});
	};

	const togglePassword = () => {
		setCredentials({ ...credentials, showPassword: !credentials.showPassword });
	};

	const toggleConfirmPassword = () => {
		setCredentials({
			...credentials,
			showConfirmPassword: !credentials.showConfirmPassword,
		});
	};

	const toggleAcceptTerms = () => {
		setCredentials({ ...credentials, tnc: !credentials.tnc });
	};

	function toggleCredentialPassword() {
		setUser({ ...user, showPassword: !user.showPassword });
	}


	  function confirm_kyc(kyc_resp) {
		if (
		  kyc_resp.status === "ACTIVE"
		) {
		  history.push("/dashboard");
		} else {
		  history.push("/login");
		}
	  }

async function submit_credentials() {
  try {
    console.log('START: Submitting credentials');
    
    // Set loading state
    setCredentials((prev) => ({ ...prev, loading: true }));

    // Retrieve and decode registration ID from localStorage
    const reg_id = localStorage.getItem('regId');
    // if (!reg_id) throw new Error('Registration ID not found in localStorage');
    // const id = atob(reg_id);

    // Make API calls sequentially
    await createIntermediary(reg_id, names, credentials);
    const loginResponse = await loginIntermediary({ ...credentials });
  

    // Fetch intermediary profile
    const kyc_resp = await (await api_srv).fetchIntermediaryProfile();
    // Optional: Uncomment if chat login is needed
    // const chat_resp = await (await api_srv).chat_login();

    // Confirm KYC response
    confirm_kyc(kyc_resp);

    // Redirect to login page
    history.push('/login');

    // Clean up localStorage and credentials
    localStorage.removeItem('REG_EMAIL');
    setCredentials({
      tnc: '',
      contact: '',
      password: '',
      username: '',
      confirmPassword: '',
      loading: false, // Reset loading state
    });

  } catch (err) {
    // Handle errors
    console.error('Error in submit_credentials:', err.message);
    setCredentials({
      tnc: '',
      contact: '',
      password: '',
      username: '',
      confirmPassword: '',
      loading: false, // Reset loading state on error
    });

    // Set alert for user feedback
    setAlert({
      message: err.message || 'An error occurred during credential submission',
      variant: 'danger',
    });
    setShowAlert(true);
    console.log('ERROR POINT REACHED');
  }
}

	return (
		<Credentials
			state={credentials}
			handleChange={handleCredentialsChange}
			togglePassword={togglePassword}
			toggleConfirmPassword={toggleConfirmPassword}
			toggleAcceptTerms={toggleAcceptTerms}
			toggleCredentialPassword={toggleCredentialPassword}
			submit_credentials={submit_credentials}
			alert={alert}
		/>
	);
};

export default CredentialsContainer;
